import React, { useEffect } from 'react';
import { useAppDispatch } from 'store';
import useNotification from 'hooks/useNotification';
import useAppNavigate from 'hooks/useAppNavigate';
import VerifyEmailPage from 'pages/Auth/VerifyEmail/VerifyEmail.component';
import { ConfirmEmailType } from 'services/Django/UserService/types';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from 'router';
import { UseFormSetError } from 'react-hook-form/dist/types/form';
import { httpService } from 'services/client';
import { updatePasswordRequest } from 'store/slices/user/actionAsync';

const ConfirmUpdatePassword: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const { errorNotification } = useNotification();
  const location = useLocation();

  const isRedirectedFromParent = location.state?.isRedirectedFromParent;

  const email = location.state?.email;

  const onSubmit = async (data: ConfirmEmailType, setErrorCallback: UseFormSetError<{ code: string }>) => {
    const { code } = data;
    const verifyCodeResponse: any = await httpService.UserService.verifyEmailCodeRequest(code);
    if (verifyCodeResponse.isError) {
      setErrorCallback('code', { message: 'Invalid verification code', type: 'custom' });
      return;
    }
    navigate(AppRoutes.UPDATE_PASSWORD, { state: { email, code } });
  };

  const onResendCode = async () => {
    try {
      await dispatch(updatePasswordRequest(email)).unwrap();
    } catch (error: any) {
      errorNotification(error.message);
    }
  };

  useEffect(() => {
    dispatch(updatePasswordRequest(email)).unwrap();
    if (!isRedirectedFromParent) {
      navigate(AppRoutes.SIGN_IN);
    }
  }, []);

  return (
    <VerifyEmailPage
      onSubmit={onSubmit}
      onResendCode={onResendCode}
      text="A verification code was sent to the address. Enter the received code below"
    />
  );
};

export default ConfirmUpdatePassword;
